export enum EnumProductType {
  Cdt = 'CDT'
}
